import { Navigate, useLocation } from "react-router-dom";
import { useMe } from "../lib/auth";

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { data: me, isLoading } = useMe();
  const loc = useLocation();
  if (isLoading) {
    return (
      <div className="min-h-screen grid place-items-center text-ios-muted">
        <div className="animate-fade-in">Lade…</div>
      </div>
    );
  }
  if (!me) {
    return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
  }
  return <>{children}</>;
}
